import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllBillToLocations,
  selectAllServiceLocations,
} from '@user/store/entityLocations'

export function useTabActions() {
  const [tab, setTab] = useState(0)

  const onChangeTab = useCallback(
    (_, newTab: number) => void setTab(newTab),
    [],
  )

  const billToLocations = useSelector(selectAllBillToLocations)
  const serviceLocations = useSelector(selectAllServiceLocations)

  return {
    tab,
    onChangeTab,
    billToLocations,
    serviceLocations,
  }
}
